import React, { useState } from 'react';
import service1 from "../../assets/img/cuartos/CUARTO1.jpg";

function ReservationSummary() {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        discountCode: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    
return (
    <div style={{ backgroundColor: '#f8f9fa', paddingTop: '100px' }}>
         <div className="text-center mb-4">
                <p className="text-muted"></p>
            </div>
        {/* Resumen de Reservación */}
        <div className="container pb-5">
            <div className="text-center mb-4">
                <div className="about-title second-title pb-25">
                    <h5>Hotel La Finca</h5>
                    <h2 style={{ fontSize: '36px' }}>Detalles de la Reserva</h2>
                    <p className="text-muted">Verifica los detalles antes de continuar</p>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-md-10 col-lg-8">
                    <div className="card shadow-sm border-0 rounded overflow-hidden">
                        <div className="row g-0">
                            <div className="col-md-5">
                                <img 
                                    src={service1} 
                                    alt="Habitación King" 
                                    className="img-fluid h-100 w-100 object-fit-cover"
                                    style={{ objectFit: 'cover' }}
                                />
                            </div>
                            <div className="col-md-7">
                                <div className="card-body p-4">
                                    <table className="table table-bordered align-middle mb-4">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Tipo de Habitación</th>
                                                <th className="text-center">Cantidad</th>
                                                <th className="text-end">Precio Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Habitación King</td>
                                                <td className="text-center">2</td>
                                                <td className="text-end">$5,000 MXN</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="2" className="text-end fw-bold">Total:</td>
                                                <td className="text-end fw-bold">$5,000 MXN</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                    <div className="text-end">
                                        <button className="btn btn-primary">
                                            Regresar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Información del Cliente */}
        <div className="container pt-4 pb-5">
            <div className="text-center mb-4">
                <div className="about-title second-title pb-25">
                    {/* <h5>Hotel La Finca</h5> */}
                    <h2 style={{ fontSize: '36px' }}>Información del Cliente</h2>
                    <p className="text-muted">Por favor completa tus datos para continuar</p>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-md-8">
                    <form className="bg-white p-4 shadow-sm rounded">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label" htmlFor="firstName">Nombre</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="firstName"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label" htmlFor="lastName">Apellido</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="lastName"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label" htmlFor="email">Correo Electrónico</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label" htmlFor="phone">Teléfono</label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    id="phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label" htmlFor="discountCode">Código de Descuento</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="discountCode"
                                    name="discountCode"
                                    value={formData.discountCode}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="text-center mt-4">
                            <button type="submit" className="btn ss-btn px-4 py-2">
                                Continuar con el Pago
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
);

}

export default ReservationSummary;
